import { DefaultResponseHandler } from "./ResponseHandler";
/**
 * DefaultResponseHandlerを継承し、ステータスコード404のレスポンスに対してエラー画面に遷移させないようにしたResponseHandlerです。
 */
export class NonRedirect404ResponseHandler extends DefaultResponseHandler {
    handleError(response, config) {
        let status = response.status;
        let message = this.errors[status] || response.statusText;
        if (status === 404) {
            throw this.error(status, message, null);
        }
        super.handleError(response, config);
    }
}
